var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefrigerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: -426,
    y: -337,
    display: "none",
    fill: "#6DCFF6",
    width: 544,
    height: 455
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refrigerator"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3,0H16.7C12.5,0,9,3.5,9,7.5V22v2v32.5c0,4,3.5,7.5,7.7,7.5h30.7c4.1,0,7.7-3.5,7.7-7.5V24v-2V7.5 C55,3.5,51.4,0,47.3,0z M53,56.5c0,2.9-2.6,5.5-5.7,5.5H16.7c-3,0-5.7-2.6-5.7-5.5V24h42V56.5z M11,22V7.5C11,4.6,13.6,2,16.7,2 h30.6c3,0,5.7,2.6,5.7,5.5V22H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,5C15.1,5,14,6.1,14,7.5v9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-9C19,6.1,17.9,5,16.5,5z M17,16.5 c0,0.3-0.2,0.5-0.5,0.5S16,16.8,16,16.5v-9C16,7.2,16.2,7,16.5,7S17,7.2,17,7.5V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,45.8c1.4,0,2.5-1.1,2.5-2.4V29.3c0-1.3-1.1-2.4-2.5-2.4S14,27.9,14,29.3v14.1C14,44.7,15.1,45.8,16.5,45.8z M16,29.3 c0-0.2,0.2-0.4,0.5-0.4s0.5,0.2,0.5,0.4v14.1c0,0.2-0.2,0.4-0.5,0.4S16,43.6,16,43.4V29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,10.1c-0.6,0-1,0.4-1,1V18c0,0.6,0.4,1,1,1s1-0.4,1-1v-6.9C50,10.6,49.6,10.1,49,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,53.7c0.6,0,1-0.4,1-1V28.1c0-0.6-0.4-1-1-1s-1,0.4-1,1v24.6C48,53.2,48.4,53.7,49,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,5.5c-0.6,0-1,0.4-1,1v1.1c0,0.6,0.4,1,1,1s1-0.4,1-1V6.5C50,5.9,49.6,5.5,49,5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerator);
export default __webpack_public_path__ + "static/media/refrigerator.5dc545d0d64a7e40704833c2cdb45293.svg";
export { ForwardRef as ReactComponent };